/*
Usage Instructions:

Include this javascript file in the theme.liquid file. 

Example on Dawn Theme:
{%- if settings.cart_type == 'drawer' -%}
    {%- render 'cart-drawer' -%}

  <script src="{{ 'skio-cart-options.js' | asset_url }}" type="module"></script>
{%- endif -%}

Then be sure to include the <skio-cart-options> element in your cart file. Whether that be liquid or javascript based. 

Example on Dawn Theme:

<td style="grid-column: 2 / 5; padding-top: 0;"> 
  <skio-cart-options item='{{ item | json }}' line='{{ forloop.index }}'></skio-cart-options>
</td>

You can pass information to the component by using properties or even by using javascript to set the properties: document.querySelector('skio-cart-options').item = {}; 

Ensure the cart is properly updated after the user selects a new selling plan by updating the function updateLineItem in this file to perform an update action to the cart. 
As of now this is built to be used with the Section Rendering API, but can be used with any AJAX cart or setup with some tweaking.
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js';

const skioCartStyles = css`
  :host {
    font-size: 16px;
    display: block;
    margin: 0.5rem 0;
  }

  button {
    background: #af7f74;
    color: white;
    border: 1px solid #af7f74;
    outline: none;
    cursor: pointer;
    padding: 0.5rem 1rem;
    width: fit-content;
    transition: all 0.3s ease-in-out;
    font-weight: 500;
    letter-spacing: 0.5px;
    font-family: inherit;
    border-radius: 2rem;
  }

  button:hover {
    background: transparent;
    color: #af7f74;
  }

  button:focus-visible {
    outline: 2px solid black;
  }

  p {
    margin: 0;
  }
`;

export class SkioCartOptions extends LitElement {
  static styles = skioCartStyles;

  static properties = {
    item: { type: Object },
    line: { type: Number },

    product: { type: Object },
    selectedVariant: { type: Object },
  };

  constructor() {
    super();

    this.item = null;
    this.line = null;

    this.product = null;
    this.selectedVariant = null;
  }

  async connectedCallback() {
    super.connectedCallback();

    if(this.item && !this.product) {
      const product = await this.fetchProduct(this.item.handle);
      this.product = product;
      this.selectedVariant = product.variants.find(variant => variant.id == this.item.variant_id);

      console.log(this.item, this.line)
    }
  }

  upgradeButton = () => {
    return html`
      <button 
        class="skio-cart-upgrade" 
        type="button" 
        @click=${() => this.updateLineItem()}>
          Add Another & Save 10%
      </button>
    `;
  }

  render() {
    if(!this.item || !this.product || !this.selectedVariant) return;

    return this.upgradeButton();
  }

  updateLineItem() {    
    if(!this.line || !this.item) return;

    const data = JSON.stringify({
      line: this.line,
      quantity: this.item.quantity + 1,
    })

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data
    })
    .then((response) => response.text())
    .then((state) => {
      Shopify.theme.jsAjaxCart.updateView();
    })
  }
 
  fetchProduct = async(handle) => {
    return new Promise(async (resolve, reject) => {
      let productCache = window.sessionStorage.skioCartProductCache ? JSON.parse(window.sessionStorage.skioCartProductCache) : [];
      let cachedProduct = productCache ? productCache.find(product => product.handle == handle) : null;
      
      if(cachedProduct) {
        resolve(cachedProduct)
      } else {
        await fetch(`/products/${ handle }.js`)
        .then((response) => response.json())
        .then((response) => {
          productCache.push(response);
          window.sessionStorage.skioCartProductCache = JSON.stringify(productCache);
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      }
    });
  }
}

customElements.define('skio-cart-options', SkioCartOptions);